export const GET_APP_CONFIG_REQUEST = 'GET_APP_CONFIG_REQUEST';
export const GET_APP_CONFIG_SUCCESS = 'GET_APP_CONFIG_SUCCESS';
export const GET_APP_CONFIG_FAILURE = 'GET_APP_CONFIG_FAILURE';
export const APP_INIT_SUCCESS = 'APP_INIT_SUCCESS';

export const SET_APP_VIEW = 'SET_APP_VIEW';
